import Cookies from 'js-cookie';

import { ERROR_CODES } from '../enums';

export const setCookie = (name, value, options) => Cookies.set(name, value, options);

export const getCookie = name => Cookies.get(name);

export const TERMS_AGREEMENT = 'TermsAgreement';

export const COOKIE_VALUE = 'drsa';

export const CALL_ME_BACK_COOKIE = 'CallMeBack';

export const RENTAL_REGISTRATION_DONE = 'RENTAL_REGISTRATION_DONE';
export const PERSISTENCE_ENABLED = 'PERSISTENCE_ENABLED';

export const setRentalRegistrationDone = session => {
  setCookie(`${session}:${RENTAL_REGISTRATION_DONE}`, 'true', {
    expires: 30,
    path: '/',
  });
};

export const getRentalRegistrationDone = session => getCookie(`${session}:${RENTAL_REGISTRATION_DONE}`) === 'true';

export const setPersistenceEnabled = (session, enabled) => {
  if (enabled) {
    setCookie(`${session}:${PERSISTENCE_ENABLED}`, 'true', {
      expires: 30,
      path: '/',
    });
  } else {
    setCookie(`${session}:${PERSISTENCE_ENABLED}`, '', {
      expires: -1,
      path: '/',
    });
  }
};

export const getPersistenceEnabled = session => getCookie(`${session}:${PERSISTENCE_ENABLED}`) === 'true';

export const getCallMeBackCookieVerificationError = () => getCookie(CALL_ME_BACK_COOKIE) === ERROR_CODES.VERIFICATION_ERROR;
